import {SettlementVendorByDocumentMovementDto} from "../../../dtos/transactions/SettlementVendorByDocumentMovementDto";
import {format} from "date-fns";
import {DataGrid} from "devextreme-react";
import {Column, ColumnChooser, Grouping, GroupPanel, Pager, Paging, SearchPanel} from "devextreme-react/data-grid";
import {MovementTypeColumn} from "./MovementTypeColumn";
import React, {useTransition} from "react";
import {useTranslation} from "react-i18next";

interface IProps {
    items: SettlementVendorByDocumentMovementDto[];
}

export const SettlementVendorByDocumentMovementTable = ({items}: IProps) => {
    const pageSizes = [10, 25, 50, 100];
    const {t} = useTranslation();

    return (
        <>
            <div className={"overflow-auto"}>
                <DataGrid
                    dataSource={items}
                    sorting={{mode: "multiple"}}
                    allowColumnReordering={true}
                    rowAlternationEnabled={false}
                    showBorders={false}
                    showRowLines={true}
                    allowColumnResizing={true}
                    selection={{mode: "single"}}
                    loadPanel={{enabled: true, showIndicator: true, showPane: false}}
                >
                    <ColumnChooser enabled={true}/>
                    <GroupPanel visible={true}/>
                    <SearchPanel visible={true} highlightCaseSensitive={true}/>
                    <Grouping autoExpandAll={false}/>

                    <Column dataField="tableMovementType"
                            dataType="string"
                            caption={"Movement Type"}
                            width={100}
                            cellRender={(column: any) => {
                                return <MovementTypeColumn column={column}/>
                            }}/>

                    <Column width={150} dataField={t("period")} dataType={"datetime"} caption={"Period"}
                            sortOrder={"asc"}
                            sortIndex={1}/>
                    <Column width={150} dataField={t("companyId")} dataType="string"/>
                    <Column width={150} dataField={t("companyName")} dataType="string"/>

                    <Column width={150} dataField={t("vendorId")} dataType="string"/>
                    <Column width={150} dataField={t("vendorName")} dataType="string"/>
                    <Column width={150} dataField={t("contractId")} dataType="string"/>
                    <Column width={150} dataField={t("contractName")} dataType="string"/>
                    <Column width={150} dataField={t("arApDocumentId")} dataType="string"/>
                    <Column width={150} dataField={t("currencyName")} dataType="string"/>
                    <Column width={150} dataField={t("currencyId")} dataType="string"/>
                    <Column width={150} dataField={t("debtOwedByVendor")} dataType="number"/>
                    <Column width={150} dataField={t("debtOwedByVendorLocal")} dataType="number"/>
                    <Column width={150} dataField={t("prepayment")} dataType="number"/>
                    <Column width={150} dataField={t("prepaymentLocal")} dataType="number"/>
                    <Column width={150} dataField={t("documentType")} dataType="number"/>
                    <Column width={150} dataField={t("businessTransaction")} dataType="number"/>

                    <Pager allowedPageSizes={pageSizes} showPageSizeSelector={true}/>
                    <Paging defaultPageSize={10}/>
                </DataGrid>
            </div>
        </>
    )
}
